import { render, staticRenderFns } from "./whitelist.vue?vue&type=template&id=0b74777e&scoped=true"
import script from "./whitelist.vue?vue&type=script&lang=js"
export * from "./whitelist.vue?vue&type=script&lang=js"
import style0 from "./whitelist.vue?vue&type=style&index=0&id=0b74777e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74777e",
  null
  
)

export default component.exports